import React, { useCallback, useMemo } from "react";
import { Typography } from "@mui/material";
import styles from "./Style.module.css";
import DataTables from "../../../../Datatables/Datatable.table";
import Constants from "../../../../config/constants";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import useEngagementTableHook from "./EngagementTable.hook";
import capitalizeFirstLetter from "../../../../hooks/CommonFunction";
import { removeUnderScore } from "../../../../helper/Helper";
import { FileDownloadOutlined } from "@mui/icons-material";

const EngagementTable = ({
  data,
  handleDetail,
  downloadTitle = "Engagement Download",
  isExport,
  handleExport,
}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    currentData,
    currentPage,
  } = useEngagementTableHook({ data });

  const tableStructure = useMemo(
    () => [
      {
        key: "module",
        label: "Module",
        sortable: false,
        render: (temp, all) => <div>{removeUnderScore(all?.type)}</div>,
      },
      {
        key: "total_time",
        label: "Total Time Spent",
        sortable: false,
        render: (temp, all) => <div>{all?.timeSpent}</div>,
      },
      {
        key: "average",
        label: "Average Time Spent",
        sortable: false,
        render: (temp, all) => <div>{all?.averageTimeSpent}</div>,
      },
    ],
    [handleDetail]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]);

  return (
    <div className={styles.wrapper}>
      <ShadowBox className={styles.w100}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"h5"}
            color={"text.primary"}
            className={styles.title}
          >
            Module Wise User Enagagement
          </Typography>

          <div>
            {isExport && (
              <div className={styles.dFlex2}>
                <Typography variant="h5" className="heading">
                  {downloadTitle}
                </Typography>
                <FileDownloadOutlined
                  onClick={handleExport}
                  color="primary"
                  size="small"
                  className={styles.expandIcon}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <div>
            <br />
            <div className={styles.w100}>
              <DataTables
                width="100%"
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default EngagementTable;
